import Swiper, { Autoplay } from "swiper";

const initSlider = ($slider) => {
  if ($slider.swiper) return $slider.swiper;

  const slideCount = $slider.querySelectorAll(".swiper-slide").length;
  const hasMultiple = slideCount > 1;

  return new Swiper($slider, {
    modules: [Autoplay],
    direction: "horizontal",
    speed: 600,
    slidesPerView: 1,
    autoHeight: true,
    loop: hasMultiple,
    allowTouchMove: hasMultiple,
    autoplay: $slider.dataset.autoplay === "true" &&
      hasMultiple && {
        delay: Number($slider.dataset.autoplayDelay) || 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
  });
};

export const announcementBanner = () => {
  const initAll = () =>
    [...document.querySelectorAll(".js-announcement-banner-slider")].map(
      initSlider
    );

  // Theme editor re-renders the section on block changes
  document.addEventListener("shopify:section:load", initAll);

  return initAll();
};

export default announcementBanner;
